import { Card, CardContent } from '../ui/card';

export const StatCard = ({ stat, index }) => (
  <Card
    className={`${stat.color} rounded-lg shadow-sm card-hover`}
    data-testid={stat.testId}
    style={{ animationDelay: `${index * 50}ms` }}
  >
    <CardContent className="p-4 md:p-6">
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0 flex-1">
          <p className={`text-[10px] md:text-sm font-medium ${stat.textColor === 'text-white' ? 'text-white/80' : 'text-[#5C5C5C]'} uppercase tracking-wide leading-tight`}>
            {stat.title}
          </p>
          <p className={`text-xl md:text-3xl font-bold mt-1 md:mt-2 ${stat.textColor} truncate`} style={{ fontFamily: 'Manrope, sans-serif' }}>
            {stat.value}
          </p>
        </div>
        <div className={`p-2 md:p-3 rounded-full flex-shrink-0 ${stat.textColor === 'text-white' ? 'bg-white/20' : 'bg-[#F4F4F0]'}`}>
          <stat.icon className={`w-4 h-4 md:w-6 md:h-6 ${stat.iconColor || stat.textColor}`} />
        </div>
      </div>
    </CardContent>
  </Card>
);
